import { PagaduriaCondicion } from './../_models/pagaduria-condicion';
import { AutenticacionService } from './autenticacion.service';
import { HttpClient } from '@angular/common/http';
import { AppSettings } from './../../proyect.conf';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PagaduriasCondicionesService {

  private rutServicio = AppSettings.rutServiciosAPL + '/api/pagaduriasCondiciones';

  constructor(private httClient: HttpClient, private autServicio: AutenticacionService) { }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as PagaduriaCondicion[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as PagaduriaCondicion[] ) );
  }

  listadoPorIdPagaduria(idPagaduria: string) {
    return this.httClient.get( this.rutServicio + '/pagaduria/' + idPagaduria ).pipe( map( res => res as PagaduriaCondicion[] ) );
  }

  listadoPorIdPagaduriaHabilitados(idPagaduria: string) {
    return this.httClient.get( this.rutServicio + '/pagaduria/' + idPagaduria + '/enabled').pipe( map( res => res as PagaduriaCondicion[] ) );
  }

  crear( regCrear: PagaduriaCondicion ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    regCrear.idUsuarioConfigura = this.autServicio.obtenerIdUsuarioLogueado();
    regCrear.ipPrivada = localStorage.getItem('ipLocal');
    regCrear.ipPublica = localStorage.getItem('ipClient');
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as PagaduriaCondicion ) );
  }

  crearEspecial( regCrear: PagaduriaCondicion ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    regCrear.idUsuarioConfigura = this.autServicio.obtenerIdUsuarioLogueado();
    regCrear.ipPrivada = localStorage.getItem('ipLocal');
    regCrear.ipPublica = localStorage.getItem('ipClient');
    return this.httClient.post( this.rutServicio + '/create', regCrear ).pipe( map( res => res as PagaduriaCondicion ) );
  }

  actualizar( regActualizar: PagaduriaCondicion ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    regActualizar.idUsuarioConfigura = this.autServicio.obtenerIdUsuarioLogueado();
    regActualizar.ipPrivada = localStorage.getItem('ipLocal');
    regActualizar.ipPublica = localStorage.getItem('ipClient');
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }

  aprobarPagaduriaCondicion( obj: PagaduriaCondicion ) {
    obj.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    obj.ipPrivada = localStorage.getItem('ipLocal');
    obj.ipPublica = localStorage.getItem('ipClient');
    return this.httClient.post( this.rutServicio + '/aprobarCondiciones', obj ).pipe( map( res => res as any ) );
  }

  denegarPagaduriaCondicion( obj: PagaduriaCondicion ) {
    obj.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    obj.ipPrivada = localStorage.getItem('ipLocal');
    obj.ipPublica = localStorage.getItem('ipClient');
    return this.httClient.post( this.rutServicio + '/denegarCondiciones', obj ).pipe( map( res => res as any ) );
  }

  enviarNotificacionAprobacion (idPagaduria: string) {
    return this.httClient.get( this.rutServicio + '/enviarNotificacionAprobacion/pagaduria/' + idPagaduria + '/usuario/'+ this.autServicio.obtenerIdUsuarioLogueado()).pipe( map( res => res as any ) );
  }

  obtenerUltimaPorEstado(idPagaduria: string, codigo: string) {
    return this.httClient.get( this.rutServicio + '/pagaduria/' + idPagaduria + '/ultimaVersion/estado/codigo/' + codigo + '/enabled').pipe( map( res => res as PagaduriaCondicion ) );
  }

}
